import config from "./config.js";

export function makeLogger(
  { endpoint, enabled }: { endpoint: string; enabled: boolean },
) {
  function init() {
    if (!enabled) return;

    window.addEventListener("error", function (event: ErrorEvent) {
      const data = {
        type: event.type,
        msg: event.message,
        file: event.filename,
        line: event.lineno,
        column: event.colno,
        // this includes platform
        browser: navigator.userAgent,
      };

      sendError(data);
    });
  }

  function sendError(data: any) {
    fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "content-type": "application/json",
      },
    });
  }

  function info(data: any) {
    console.info(`[INFO][${new Date().toLocaleTimeString()}]`, data);
  }

  function error(data: any) {
    console.error(`[ERROR][${new Date().toLocaleTimeString()}]`, data);
    sendError(data);
  }

  return {
    init,
    info,
    error,
  };
}

let enabled = true;

if (
  typeof config.errorLoggerEndpoint == "undefined" ||
  config.errorLoggerEndpoint == ""
) {
  console.warn("Error logger endpoint not configured. No logs will be sent.");
  enabled = false;
}

export const Logger = makeLogger({
  endpoint: config.errorLoggerEndpoint ?? "",
  enabled,
});
